<template>
  <component :is="tag">
    <slot v-bind="{ state }"/>
  </component>
</template>

<script setup>
import { onMounted } from "vue"
import { uniq } from "lodash-es"

const props = defineProps({
  state: { type: Object, required: true },
  tag: { type: String, default: "div" },
})

onMounted(() => {
  let recentlyViewedStates = JSON.parse(localStorage.getItem("recentlyViewedStates")) || []

  recentlyViewedStates = uniq([
    props.state.code,
    ...recentlyViewedStates,
  ])

  localStorage.setItem("recentlyViewedStates", JSON.stringify(recentlyViewedStates))
})
</script>
